'use strict'

const NullObject = function () {}
NullObject.prototype = Object.create(null)

module.exports = {
  NullObject
}
